import React, { useState } from 'react'

import CloseDialogIconButton from 'src/components/iconbutton/CloseDialogIconButton.js'
import NmotTranslationText from 'src/views/nmot/shared/NmotTranslationText'
import EditDestDialogContext from './EditDestDialogContext.js'
import EditDestDialogForm from './EditDestDialogForm.js'
import Paper from '@material-ui/core/Paper'
import { components } from 'cng-web-lib'

const { CngDialog } = components

function EditDestDialog({
  isDialogOpen,
  closeDialog,
  rowData,
  showNotification,
  cngTableRef
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const translatedTextsObject = NmotTranslationText()

  return (
    <EditDestDialogContext.Provider
      value={{
        closeDialog,
        showNotification,
        rowData,
        form: {
          isSubmitting,
          setSubmitting
        },
        cngTableRef
      }}
    >
      <CngDialog
        customDialogContent={
          <Paper>
            <div style={{ overflow: 'hidden' }}>
            <EditDestDialogForm />
            </div>
          </Paper>
        }
        dialogTitle={
          <>
            {translatedTextsObject.editDestinationTitle}
            <CloseDialogIconButton
              onClick={closeDialog}
              disabled={isSubmitting}
            />
          </>
        }
        open={isDialogOpen}
        fullWidth
        maxWidth='sm'
      />
    </EditDestDialogContext.Provider>
  )
}

export default EditDestDialog